import { render } from "./guidePage.vue?vue&type=template&id=27a2f97f&scoped=true"
import script from "./guidePage.vue?vue&type=script&lang=js"
export * from "./guidePage.vue?vue&type=script&lang=js"

import "./guidePage.vue?vue&type=style&index=0&id=27a2f97f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a2f97f"]])

export default __exports__